var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonnelPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 80,
    viewBox: "0 0 84 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2792 79.9898L42.3065 66.3369L42.3346 53.4097",
    fill: "#A9CF3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4795 80L37.0785 79.9797L37.1338 53.3984L47.5347 53.421L47.4795 80Z",
    fill: "#A9CF3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0001 38.8218C19.0905 38.8218 0.473668 56.7984 0.657354 78.8269C0.660038 78.8297 0.66179 78.8313 0.66459 78.8341H4.72188H11.0476H22.366V68.4333H12.9258C17.2767 57.2338 28.6678 49.2227 42 49.2227C55.3323 49.2227 66.7234 57.2338 71.0743 68.4333H61.6585V78.8341H72.9524H80.8623H83.3353C83.3382 78.8313 83.3398 78.8297 83.3427 78.8269C83.5268 56.7984 64.9097 38.8218 42.0001 38.8218Z",
    fill: "#587E85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3396 49.2237C28.2217 49.2237 16.7357 38.1831 16.7357 24.6118C16.7356 11.0408 28.2217 0 42.3396 0C56.4575 0 67.9434 11.0408 67.9434 24.6118C67.9434 38.1831 56.4574 49.2237 42.3396 49.2237ZM42.3396 10.4009C33.9566 10.4009 27.1366 16.7756 27.1366 24.6118C27.1366 32.4481 33.9566 38.8228 42.3396 38.8228C50.7227 38.8228 57.5425 32.4481 57.5425 24.6118C57.5425 16.7756 50.7227 10.4009 42.3396 10.4009Z",
    fill: "#A9CF3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5973 66.3901L41.9444 66.3629L29.0172 66.3347",
    fill: "#A9CF3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6074 61.1898L55.5871 71.5907L29.0059 71.5355L29.0284 61.1346L55.6074 61.1898Z",
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonnelPricing);
export default __webpack_public_path__ + "static/media/personnel-pricing.2553902f1777e8dfe39f6979c43e2be3.svg";
export { ForwardRef as ReactComponent };